var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe-source"},[(_vm.ready)?_c('iframe',{staticStyle:{"border":"none"},attrs:{"src":_vm.path,"width":"100%","height":"500px"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }